/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import '@angular/compiler';

import { environment } from './../../../environments/environment';
import { AppModule } from './app/app.module';

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

if (environment.production) {
  enableProdMode();
}

// We send stats to datadog only in production
if (environment.env === 'prod') {
  datadogRum.init({
    applicationId: '488d1b60-d24e-47cf-899a-eb031e7ed3c6',
    clientToken: 'pub119174a0f28faee012afa01a077727e3',
    site: 'datadoghq.eu',
    service: 'travelgate-web',
    env: environment.env,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogLogs.init({
    clientToken: 'pub119174a0f28faee012afa01a077727e3',
    site: 'datadoghq.eu',
    service: 'travelgate-web',
    env: environment.env,
    version: '1.0.0',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
